// extracted by mini-css-extract-plugin
export default {"section":"News_section__zSlgB","addMore":"News_addMore__ch3u3"};